import React from 'react';
import cx from 'classnames';

import units from 'ha/theme/units';

import ButtonBase, { ButtonBaseProps } from 'ha/ui/next/ButtonBase';

import { CircularProgress } from 'ha/ui/next/Progress';
import { Theme, createStyles, withStyles, WithStyles } from '@material-ui/core';
import FavoriteIcon from './FavoriteIcon';

import FavoriteButtonNext from './FavoriteButtonNext';

const styles = (t: Theme) =>
  createStyles({
    'button-medium': {
      padding: units.trbl(0.625, 1, 0.625, 1),
      width: units.rem(3),
      minWidth: units.rem(3),
      maxHeight: units.rem(2.5),
    },
    'button-small': {
      padding: units.trbl(0.4375, 1, 0.4375, 1),
      width: units.rem(2.25),
      minWidth: units.rem(2.25),
      maxHeight: units.rem(1.875),
    },
    light: {
      color: t.palette.white.main,
      background: t.palette.white.main,
      borderRadius: '3px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.5)',
      '&:hover': {
        background: t.palette.grey[300],
      },
    },
    dark: {
      color: t.palette.white.main,
      borderRadius: '3px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.5)',
      background: 'rgba(0, 0, 0, 0.6)',
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.8)',
      },
      '&:active': {
        background: 'rgba(0, 0, 0, 0.8)',
      },
      '&:focus': {
        background: 'rgba(0, 0, 0, 0.8)',
      },
    },
  });

type Styles = typeof styles;
type Variant = 'light' | 'dark';
type Size = 'small' | 'medium';

interface Props {
  onClick: React.MouseEventHandler<HTMLElement>;
  isLoading: boolean;
  isFavorite: boolean;
  size?: Size;
}

type FavoriteButtonType = (
  variant: Variant,
) => React.FC<Props & ButtonBaseProps & WithStyles<Styles>>;

const FavoriteButton: FavoriteButtonType = variant => ({
  classes,
  onClick,
  size,
  isLoading,
  isFavorite,
  children,
  ...rest
}) => (
  <ButtonBase
    className={cx(classes[`button-${size}`], classes[variant])}
    onClick={onClick}
    {...rest}
  >
    {isLoading ? (
      <CircularProgress size={20} />
    ) : isFavorite ? (
      <FavoriteIcon.Favorite kind={variant} size={size || 'medium'} />
    ) : (
      <FavoriteIcon.Unfavorite kind={variant} size={size || 'medium'} />
    )}
  </ButtonBase>
);

export default {
  Light: withStyles(styles)(FavoriteButton('light')),
  Dark: withStyles(styles)(FavoriteButton('dark')),
  Next: FavoriteButtonNext,
};
